export const sysRouters = [
    {
        path: '/login',
        name:'login',
        component: () => import('@/views/login/index'),
    },
    {
        path: '/loginForLive',
        name:'loginForLive',
        component: () => import('@/views/login/loginForLive.vue'),
    },
    {
        path: '/register',
        name:'register',
        component: () => import('@/views/register/index'),
    },
    {
        path: '/resetPassword',
        name:'resetPassword',
        component: () => import('@/views/resetPassword/index'),
    },
]